/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1Person202,
  PostApiV1Person400,
  PostApiV1Person401,
  PostApiV1Person409,
  PostApiV1Person500,
  PostApiV1PersonMutationRequest,
  PostApiV1PersonMutationResponse,
} from "../../types/personRegisterController/PostApiV1Person.ts";
import { createPersonRequestViewModelSchema } from "../createPersonRequestViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1Person202Schema =
  z.any() as unknown as ToZod<PostApiV1Person202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1Person400Schema =
  z.any() as unknown as ToZod<PostApiV1Person400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1Person401Schema =
  z.any() as unknown as ToZod<PostApiV1Person401>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const postApiV1Person409Schema =
  z.any() as unknown as ToZod<PostApiV1Person409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1Person500Schema =
  z.any() as unknown as ToZod<PostApiV1Person500>;

export const postApiV1PersonMutationRequestSchema = z.lazy(
  () => createPersonRequestViewModelSchema,
) as unknown as ToZod<PostApiV1PersonMutationRequest>;

export const postApiV1PersonMutationResponseSchema = z.lazy(
  () => postApiV1Person202Schema,
) as unknown as ToZod<PostApiV1PersonMutationResponse>;
